import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import "../css/layout.css";
import "../css/login.css";

import { apiRequest } from "../store/allApi";

export default function Login() {
  const history = useHistory();

  const [Phone, setPhone] = useState();
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const [receivedOTP, setReceivedOTP] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if ("OTPCredential" in window) {
        const ac = new AbortController();

        try {
          const otpCredential = await navigator.credenstials?.get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          });

          setReceivedOTP(otpCredential?.code);
          ac.abort();
        } catch (err) {
          ac.abort();
          console.log(err);
        }
      }
    };

    fetchData();
  }, []);

  const handleClick = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please  enter currect phone number",
      });
    } else {
      setIsloading1(true);
      try {
        const respone = await apiRequest("login", "POST", { Phone, referral });

        setIsloading1(false);
        if (respone.data.status == 101) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: respone.data.msg,
          });
        } else if (respone.data.status == 200) {
          setOtp(true);
          setSecretCode(respone.data.secret);
          if (respone.data.myToken) {
            Swal.fire({
              icon: "success",
              title: "OTP",
              text: "Demo Account Testing OTP: " + respone.data.myToken,
            });
          }
        } else if (respone?.data?.status == false) {
          Swal.fire({
            icon: "error",
            text: respone?.data?.msg,
          });
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
        });
      }
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();

    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }

    setIsloading1(true);

    try {
      const response = await apiRequest(
        "login/finish",
        "POST",
        { Phone, twofactor_code, referral, secretCode },
        null,
      );

      setIsloading1(false);

      if (response.data.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.msg,
        });
      } else if (response.data.status === 200) {
        const token = response.data.token;
        localStorage.setItem("token", token);
        // Reload the page and redirect after a delay
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games"); // Assuming you have 'history' available
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  // otp valid
  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timerInterval;

    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timerInterval);
      setShowResend(true); // Show the Resend button when OTP expires
      setIsValid(false);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsValid(true);
    setSeconds(60);
    setShowResend(false); // Hide the Resend button after clicking it
  };
  return (
    <>
      <div
        className="leftContainer login-screen-shell"
        style={{ minHeight: "100vh" }}
      >
        <div className="glass-wrapper login-redesign">
          {/* <div className="login-bg-grid"></div> */}
          <div className="shape circle-1"></div>
          <div className="shape circle-2"></div>
          <div className="shape circle-3"></div>

          <div>
            <div className="glass-card">
              <div className="glass-header">
                <div className="form-logo">
                  <img src="/logo.png" alt="logo" class="floating-logo"></img>
                </div>
                <h2>
                  {otp ? "Verify OTP" : "Login Account"}{" "}
                  <span className="hero-pill">Fast OTP Login</span>
                </h2>
                <p>
                  {otp
                    ? "Enter the code sent to your mobile number"
                    : "Enter your mobile number to continue"}
                </p>
              </div>

              <div className="glass-body">
                <div className="floating-input-group">
                  <div className="input-icon-box">
                    <span className="country-tag">+91</span>
                  </div>
                  <input
                    name="mobile"
                    type="tel"
                    className="glass-input"
                    placeholder="Mobile number"
                    onChange={(e) => {
                      setPhone(e.target.value);
                      if (e.target.value.length > 10) {
                      }
                    }}
                  />
                </div>

                {otp && (
                  <div className="otp-container-animated">
                    <div className="floating-input-group">
                      <div className="input-icon-box">
                        <span className="otp-label">OTP</span>
                      </div>
                      <input
                        name="password"
                        type="tel"
                        className="glass-input"
                        placeholder="Enter 6-digit code"
                        autoComplete="one-time-code"
                        onChange={(e) => settwofactor_code(e.target.value)}
                      />
                    </div>

                    <div className="resend-wrapper">
                      {isValid || seconds > 0 ? (
                        <div className="timer-badge">
                          Code expires in <span>{seconds}s</span>
                        </div>
                      ) : (
                        showResend && (
                          <button
                            className="text-resend-btn"
                            onClick={handleResendClick}
                          >
                            Resend code
                          </button>
                        )
                      )}
                    </div>
                  </div>
                )}

                <div className="action-area">
                  {!otp ? (
                    <button
                      className={`gradient-btn ${isLoading1 ? "loading" : ""}`}
                      onClick={(e) => {
                        handleClick(e);
                        setIsValid(true);
                      }}
                      disabled={isLoading1}
                    >
                      {isLoading1 ? (
                        <div className="loader-dots">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      ) : (
                        "Get verification code"
                      )}
                    </button>
                  ) : (
                    <button
                      className={`gradient-btn ${isLoading1 ? "loading" : ""}`}
                      onClick={(e) => varifyOtp(e)}
                      disabled={isLoading1}
                    >
                      {isLoading1 ? (
                        <div className="loader-dots">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      ) : (
                        "Confirm and login"
                      )}
                    </button>
                  )}
                </div>

                <div className="login-safe-note">
                  <span></span>
                  <p>
                    By continuing, you confirm that you are eligible to play on
                    this platform.
                  </p>
                </div>
              </div>
            </div>

            {/* <div className="brand-lockup">
              <img
                src="/logo.png"
                alt="logo"
                className="floating-logo"
              />
              <div>
                <span className="brand-kicker">Skill gaming</span>
                <h1>MrLudoHub</h1>
              </div>
            </div> */}

            <div className="login-benefits">
              <div>
                <strong>24/7</strong>
                <span>Support</span>
              </div>
              <div>
                <strong>UPI</strong>
                <span>Withdrawals</span>
              </div>
              <div>
                <strong>OTP</strong>
                <span>Protected</span>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="login-footer mb-5">
            By continuing I agree that MrLudoHub may
            store and process my data in accordance with the{" "}
            <Link to="/about">About</Link> <Link to="/contact-us">Contact</Link>{" "}
            <Link to="/Terms">Privacy Policy</Link> and that I am 18 years or
            older. I am not playing from Assam, Odisha, Nagaland, Sikkim,
            Meghalaya, Andhra Pradesh, or Telangana.
          </div> */}
      </div>
    </>
  );
}
